export const updatesData = [
   
  {
    version: "0.4.3",
    date: "2025-09-29",
    details: [
      "เพิ่มข้อมูล: Model Add bank account เมื่อเลือกเพิ่มธนาคาร KTB ประเภทฝากเงิน จะต้องเลือก เปิด/ปิดใช้งาน prompt pay (สำหรับบัญชี ที่สมัครใช้งาน prompt pay เท่านั้น)",
      "เพิ่มฟังก์ชันใหม่: เพิ่ม Tabs Menu แดชบอร์ด ที่เมนู แดชบอร์ด",
      "แก้ไขฟังชั่น: แก้ไขฟังชั่น สรุปภาพรวม",
      "แก้ไขฟังชั่น: แก้ไขฟังชั่น Edit Permissions สามามรถเพิ่มการเข้าถึงเมนูได้",
      "ปรับปรุงฟังชั่นเรียก: API  ทั้งหมด ให้ทำงานได้ดีขึ้น ",
    ],
  },
  {
    version: "0.4.2",
    date: "2025-09-08",
    details: [
      "แก้ไขฟังชั่น: เมนู Slip Verification's เพิ่มฟังชั้น Verify โดยแบ่งประเภทการ Verify ได้ 2 แบบ คือ แจ้งฝาก (แบบมีสลิป) (Deposit (with slip)) และ แจ้งฝาก (แบบไม่มีสลิป) (Deposit (without slip)) ",
      "เพิ่มฟังก์ชันใหม่: เพิ่มฟั่งชั่น Re-Send หน้า ฝาก-ถอน",
      "ปรับปรุงฟังชั่นเรียก: API  invoices ",
      "แก้ไขฟังชั่น: Re-Send แก้ปัญหาเมื่อ เลือกวันที่แล้ว กด Re-Send ไม่ได้",
    ],
  },
  {
    version: "0.4.1",
    date: "2025-08-25",
    details: [
      "เพิ่มฟังก์ชันใหม่: เมนู Slip Verification's เพิ่มฟังชั้น Verify โดยแบ่งประเภทการ Verify ได้ 2 แบบ คือ แจ้งฝาก (แบบมีสลิป) (Deposit (with slip)) และ แจ้งฝาก (แบบไม่มีสลิป) (Deposit (without slip)) ",
      "แก้ไขฟังชั่น: ลบปุ่ม แจ้งฝากเงิน ที่เมนู => Payin => Tab: สร้างรายการฝากทั้งหมด (เมื่อรายการมีสถานะ PENDING) โดยการตรวสอบรายการฝาก จะต้องใช้งานที่เมนู Slip Verification's",
      "ยกเลิก: ยกเลิกใช้งานฟังชั่น สร้างรายการฝาก ",
    ],
  },
  {
    version: "0.4.0",
    date: "2025-08-15",
    details: [
      "เพิ่มฟังก์ชันใหม่: สามารถเพิ่มบัญชีธนาคารลูกค้าได้ ที่ หน้าเมนูลูกค้า=> เพิ่มลูกค้า",
      "เพิ่มฟังก์ชันใหม่: สามารถค้นหา (ชื่อ-สกุล) ลูกค้าได้แล้ว",
      "เพิ่มฟังก์ชันใหม่: ฝากเงิน => Tabs 'สร้างรายการฝาก' สามารถแจ้งฝากเงิน โดยอัพสลิปการฝากเงิน เมื่อรายการมีสถานะ PENDING",
      "อัพเดท: ฟอร์ม Model สร้างรายการฝาก : สามารถค้นหา Customer (ค้นหาด้วยชื่อ-สกุล)",
      "เพิ่มฟังชั่น: Table / Chart View ที่เมนู สรุปภาพรวม เพิ่ม Pie Chart แสดงข้อมูล สรุปภาพรวม",
      "ปรับปรุงฟังชั่นเรียก API ให้ทำงานได้อย่างมีประสิธิภาพ",
      "เพิ่มฟังก์ชันใหม่: สำหรับบัญชีประเภทฝากเงิน สามารถเลือก 'ประเภทการชำระเงิน' => 'QR_PAY', 'BANK_PAY' ท่านสามารถตั้งค่าได้ที่เมนู บัญชีธนาคาร/จัดการบัญชีธนาคาร",
      "เปิดใช้งาน: บอทแสดงรายการดึงรายการฝากเงิน 10 รายการล่าสุด (เมนู สถานะบัญชี ประเภท ฝากเงิน)",
      "เปิดใช้งาน: บอทแสดงรายการดึงรายการฝากเงิน 10 รายการล่าสุด (เมนู สถานะบัญชี ประเภท ฝากเงิน) แสดงข้อมูล Transaction List ",
      "แก้ไขฟังชั่น: Add user admin  สามารถใช้งานได้",
      "แก้ไขฟังชั่น: เปิด/ปิด ใช้งาน merchant",
      "แก้ไขฟังชั่น: Menu ฝั่งซ้ายไม่มา",
      "ปรับปรุงฟังชั่นเรียก API ให้ทำงานได้อย่างมีประสิธิภาพ (2)",
      "แก้ไข เมื่อ Token หมดายุ ให้กลับไปที่หน้า ล็อกอิน",
      "แก้ไขปัญหา ที่เมนู จัดการบัญชีธนาคาร เมื่อรีโหลดหน้าบราวเซอร์ แล้วข้อมูลไม่มา ท่าน สามารถอัพเดทข้อมูลล่าสุดได้ที่ ปุ่มเครืองมือมุมขวาล่าง => กดไอคอน Reload, หรือ มุมขวาบน => กดไอคอน Reload",
      "แก้ไข Model เพิ่มบัญชีธนาคาร เมื่อเลือก Channel Scb Business เดิม label จะเป็น PIN แก้ไขเป็น PASSWORD",
      "แก้ไขฟั่งชั่นค้นหา withdraw และ deposit กดหน้าถัดไปแล้วข้อมูลไม่เปลี่ยน"
    ],
  },
  {
    version: "0.3.9",
    date: "2025-08-12",
    details: [
      "เพิ่มข้อมูล: Model Details Merchant : เพิ่มข้อมูล Username , password ฯลฯ สามารถตรวจสอบได้ที่ เมนู จัดการร้านค้า => รายละเอียด, (* ร้านค้าที่สร้างก่อนวันที่ 12/8/2025 จะไม่มีข้อมูล password)",
      "เพิ่มฟังก์ชันใหม่: เพิ่มฟังชั่นแจ้งเตือนยอดเงิน (ถอน) ใกล้จะหมด ท่านสามารถ ตั้งค่ายอดเงินได้ด้วยตัวเอง ที่ (มุมขวาล่าง) และ ปิดการแจ้งเตือนหรือปิดเสียงได้ตามต้องการ. (ข้อมูลการตั้งค่า จะเก็บใว้ใน localStorage เมื่อท่าน ลบข้อมูลการท่องเว็บ (chrome) ข้อมูลจะกลับมาค่าเริ่มต้นคือ แจ้งเตือน : เปิด | เสียงเตือน: เปิด, จำนวนเงินน้อยกว่า: 5000 จะแจ้งเตือน)",
      "เพิ่มฟังก์ชันใหม่: อัพเดทข้อมูล (มุมขวาล่าง)",
      "เพิ่มฟังก์ชันใหม่: เพิ่มฟังก์ชันยืนยันบัญชี (customer) ที่มีสถานะ PENDING => SUCCESS",
      "ปรับปรุง: Css Table, Model เพื่อรองรับทุกขนาดหน้าจอ",
      "แก้ไขหน้าขาว: เมนู จัดการร้านค้า Role: Owner ",
      "แก้ไข: เมนู จัดการบัญชีธนาคาร บัญชีธนาคารที่ ลบ  ไม่ต้องไปแสดงที่ Tabs 'Verify' จะแสดงแค่ Tabs 'Suspended'",
      "แก้ไข: รูปแบบ เลขบัญชี, เบอร์โทรศัพ, เพิ่ม Icon ธนาคาร",
      "เพิ่มฟังชั่น: แสดงยอดเงินเหลือ สำหรับบัญชีถอนเงิน ที่ใช้งานอยู่ขณะนั้น จะแสดงที่ Navbar ,  Navmenu",
    ],
  },
  {
    version: "0.3.8",
    date: "2025-08-11",
    details: [
      "เพิ่มฟังก์ชันใหม่: 'อัพเดตยอดเครดิต' , 'อัพเดตยอดใบแจ้งหนี้'",
      `เพิ่มฟังก์ชันใหม่: ฟังชั่นแจ้งเตือนเมื่อมีการ แก้ไข/อัพเดท การใช้งานในส่วนหลังบ้าน ระบบแจ้งเตือนนี้มีอายุ 72 ชม. (3วัน) 
        นับจากวันที่อัพเดทล่าสุด ท่านสามารถ 'คลิกที่ปุ่มสีแดง' เพื่อไม่ให้มีการแจ้งเตือนอีก จนกว่าจะมีการอัพเดทใหม่ หรือปุ่มสีฟ้า เพื่อดูรายละเอียด `,
      "เพิ่มฟังก์ชันใหม่: สามารถติดตั้ง PayEasy App (มุมขวาล่าง) เพื่อง่ายต่อการเข้าใช้งาน ",
      "แก้ไข: การเลือกดูตาม ช่วงเวลา ใบแจ้งหนี้ (invoices)' และสามารถส่งออกข้อมูลเป็น PDF ได้",
      "ปิดปรับปรุง: Table / Bar Chart View ที่เมนู สรุปภาพรวม เนื่องจากกราแสดงผล Css มีปัญหา แต่ท่านยังคงสามารถดู สรุปภาพรวม ได้ปกติใน Tabs : Card view",
    ],
  },
  {
    version: "0.3.7",
    date: "2025-08-10",
    details: [
      "แก้ไข: ฟอร์ม Qrcode ฝากเงิน/สร้างรายการฝาก เมื่อโอนเงินเสร็จ ให้กดปุ่ม 'โอนเงินสำเร็จ' เพื่อกลับไปยัง หน้าฝากเงิน",
      "แก้ไข: ฟอร์ม Model สร้างรายการฝาก : จากเดิมให้เลือกลูกค้า เปลี่ยนเป็นให้กรอก Customer UUID ด้วยตัวเองเอง ซึงสามารถ Copy Customer UUID ได้ที่ หน้า Customer (ลูกค้า)",
    ],
  },

  // เพิ่มข้อมูลเวอร์ชันอื่นๆ ที่นี่...
];
